import fetch from 'isomorphic-fetch'
import { URL } from '../constants/api'

function getDefaultHeaders() {
  return {
  'Content-Type': 'application/json'
  }
}

const request = function(url, method = 'GET', body) {
  return new Promise(function(resolve, reject) {
    fetch(url, {
      method: method,
			headers: getDefaultHeaders(),
			body: JSON.stringify(body)
    }).then(function(response) {
      response.json().then(function(data){
        if (response.ok)
          resolve(data)
        else
          reject(data)
      })
    }).catch(function(err){
      reject([err.toString()])
    })
  })
}

export default {
  fetchNewsletterList(pl=8,p='') {
    var ENDPOINT = URL + 'newsletter' + '?pl=' + pl + '&page=' + p
    return request(ENDPOINT, 'GET')
  },
  fetchNewletterSectors(){
    var ENDPOINT = URL + 'sectors/'
    return request(ENDPOINT, 'GET')
  },
  fetchNewsletterSectors(sectors) {
    var ENDPOINT = URL + 'sectors?featured=' + JSON.stringify(sectors)
    return request(ENDPOINT, 'GET')
  },
  fetchNewsletterBySector(id) {
    var ENDPOINT = URL + 'newsletter?sector=' + id
    return request(ENDPOINT, 'GET')
  },
  fetchNewsletterByWords(value){
    var ENDPOINT = URL + 'newsletter?' + 'featured_words=' + value
    return request(ENDPOINT, 'GET')
  },
  fetchFilterNewsletters(m, y){
    var ENDPOINT = URL + 'newsletter/?' + 'year=' + y + '&month=' + m
    return request(ENDPOINT, 'GET')
  },
  fetchNewsletterDates(){
    var ENDPOINT = URL + 'newsletter/dates'
    return request(ENDPOINT, 'GET')
  },
  fetchNewsletterById(id){
    var ENDPOINT = URL + 'newsletter/' + id
    return request(ENDPOINT, 'GET')
  },
  fetchNotes(id){
    var ENDPOINT = URL + 'notes?' + 'newsletter=' + id
    return request(ENDPOINT, 'GET')
  },
  fetchNotesBySector(value, idImi){
    var params = {'category_type=': value, 'imi_id': idImi}
    var ENDPOINT = URL + 'notes?q=' + JSON.stringify(params)
    return request(ENDPOINT, 'GET')
  },
  fetchNotesByWords(value){
    var ENDPOINT = URL + 'notes?' + 'featured_words=' + value
    return request(ENDPOINT, 'GET')
  },
  fetchNoteById(id){
    var ENDPOINT = URL + 'notes/' + id
    return request(ENDPOINT, 'GET')
  },
	suscribe(email){
		var ENDPOINT = URL + 'users/suscribe'
    return request(ENDPOINT, 'POST', { email: email } )
	}
}



// WEBPACK FOOTER //
// ./src/api/newsletter.js